/**
 * Setup-attention chrome — “needs action”, not a marketplace brand and not danger.
 *
 * Soft pink (`#fa3a92` family) is also the ops/admin console brand, but marketplace
 * users never see that console, so there is no collision for them. Red is reserved
 * for true danger (errors, destructive actions).
 *
 * Avoids vertical brands: FTT emerald · Stays amber · Thrifts sky · Moves indigo.
 *
 * Use for: PIN missing, onboarding incomplete, location/photo setup, profile
 * settings attention. Do not use for star ratings or error/danger UI.
 */
export const setupAttention = {
  panel:
    'rounded-[1.5rem] border border-pink-300 bg-gradient-to-br from-pink-50 via-white to-stone-50 p-5 text-sm text-pink-950 shadow-sm',
  panelCompact:
    'rounded-[1.5rem] border border-pink-300 bg-pink-50 p-4 text-sm text-pink-950 shadow-sm',
  chip: 'inline-flex items-center gap-2 rounded-full border border-pink-200 bg-pink-100 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-pink-900',
  /** Soft pink accent (~#fa3a92), not deep blood-red. */
  cta: 'inline-flex items-center justify-center rounded-xl bg-pink-600 px-4 py-2 text-sm font-semibold text-white hover:bg-pink-700',
  ctaSecondary:
    'inline-flex items-center justify-center gap-2 rounded-xl border border-pink-300 bg-white px-4 py-2 text-sm font-semibold text-pink-950 hover:bg-pink-50',
  incompleteRow: 'border-pink-200 bg-white',
  incompleteMark: 'bg-pink-100 text-pink-800',
  linkBorder: 'border-pink-300',
  linkDetail: 'text-pink-900',
  linkDot: 'bg-pink-500',
} as const
